import { Flex, Space, Tooltip, Typography } from "antd"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

import ButtonComponent from "../../../../../Components/Button"
import { titleSortFilters } from "../../../../../Components/titleSortFilters"
import Icon from "../../../../../Icon"
import { alertsColumnIconMap, dateFormat, formatCurrency } from "../../../../../Utils/utils"
import StatusTag from "../StatusTag/StatusTag"

const { Text, Link } = Typography

dayjs.extend(utc)

export const getColumns = ({ statuses, onStatusChange }) =>
  // {
  //   type: {
  //     key: 'type',
  //     // sorter: true,
  //     title: (state) =>
  //       titleSortFilters({
  //         title: 'Type',
  //         sorter: true,
  //         icon: 'type',
  //         stateData: state,
  //         key: 'type',
  //       }),
  //     dataIndex: 'type',
  //     // width: 185,
  //   },
  // },
  ({
    id: {
      key: "sequence_number",
      sorter: true,
      title: (state) =>
        titleSortFilters({
          title: "",
          sorter: true,
          icon: alertsColumnIconMap["id"],
          stateData: state,
          key: "sequence_number"
        }),
      dataIndex: "sequence_number",
      width: 60,
      maxWidth: 70
    },
    status: {
      key: "status",
      sorter: true,
      title: (state) =>
        titleSortFilters({
          title: "Status",
          sorter: true,
          icon: alertsColumnIconMap["status"],
          stateData: state,
          key: "status"
        }),
      dataIndex: "status",
      width: 150,
      maxWidth: 150,
      render: (status, record) => {
        if (!status) return "—"
        return (
          <StatusTag
            status={status}
            withDropdown={status === "Pending"}
            options={statuses}
            onChange={(newStatus) => onStatusChange({ id: record.id, newStatus })}
          />
        )
      }
    },
    user_full_name: {
      key: "user_full_name",
      // sorter: true,
      title: (state) =>
        titleSortFilters({
          title: "User full name",
          // sorter: true,
          icon: alertsColumnIconMap["user_full_name"],
          stateData: state,
          key: "user_full_name"
        }),
      dataIndex: "user_full_name",
      width: 185
    },
    user_email: {
      key: "user_email",
      // sorter: true,
      title: (state) =>
        titleSortFilters({
          title: "User email",
          // sorter: true,
          icon: alertsColumnIconMap["user_email"],
          stateData: state,
          key: "user_email"
        }),
      dataIndex: "user_email"
      //width: 185,
    },
    created_timestamp: {
      key: "created_timestamp",
      sorter: true,
      title: (state) =>
        titleSortFilters({
          title: "Created date",
          sorter: true,
          icon: alertsColumnIconMap["created_timestamp"],
          stateData: state,
          key: "created_timestamp"
        }),
      dataIndex: "created_timestamp",
      width: 185,
      render: (_) => (
        <Space direction="vertical" size={4}>
          <Text>{dayjs(_).format(dateFormat)}</Text>
          <Text type="secondary">{dayjs(_).format("h:mm A [(UTC)]")}</Text>
        </Space>
      )
    },
    amount: {
      key: "amount",
      // sorter: true,
      title: (state) =>
        titleSortFilters({
          title: "Sum",
          // sorter: true,
          icon: alertsColumnIconMap["sum"],
          stateData: state,
          key: "amount"
        }),
      dataIndex: "amount",
      width: 100,
      render: (amount) => <Text>{amount ? formatCurrency(amount) : "—"}</Text>
      // align: 'center',
    }
  })

export const getDefaultColumn = ({ field_id, label }) => ({
  key: field_id,
  // sorter: true,
  title: (state) =>
    titleSortFilters({
      title: label,
      // sorter: true,
      icon: alertsColumnIconMap[field_id],
      stateData: state,
      key: field_id
    }),
  dataIndex: field_id,
  //ellipsis: true,
  width: 200,
  render: (value) => <Text>{value || "—"}</Text>
})

export const getActionColumn = ({ onSelectRow }) => ({
  key: "actions",
  title: (state) =>
    titleSortFilters({
      title: "Actions",
      sorter: false,
      //icon: 'delete',
      stateData: state,
      key: "delete"
    }),
  //align: 'right',
  width: 136,
  render: (_, record) => {
    const handleAction = (e, data, type) => {
      e.preventDefault()
      e.stopPropagation()
      onSelectRow(data, type)
    }
    return (
      <Flex gap={4}>
        <Tooltip title="Delete attachments">
          <ButtonComponent
            danger
            type="link"
            shape="circle"
            disabled={!record?.admin_screenshots?.length}
            icon={<Icon type="delete" />}
            onClick={(e) => handleAction(e, record, "delete")}
            className="flex center table-action-btn"
          />
        </Tooltip>
      </Flex>
    )
  }
})
